import { useAppContext } from '../../AppContext';
import { UserAvatar } from './UserAvatar';
import { CreatorType } from '../../Types';
import PropTypes from 'prop-types';

export const UsersStack = (props) => {
  const context = useAppContext();
  const users = props.users || [];

  const userCount = users.length;
  if (userCount === 0 ) {
    return null;
  }

  if (userCount < 3) {
    return (<div className="vkuiUsersStack vkuiUsersStack--ios vkuiUsersStack--size-s vkuiUsersStack--l-horizontal UsersStackSmall">
      <div role="presentation" className="vkuiUsersStack__photos">
        {users.map((user) => (<div className="" key={user.id || user.name || user.img}>
          <UserAvatar type={user.type} src={user.img} name={user.name} size={24} id={user.id} />
        </div>))}
      </div>
      <span className="vkuiUsersStack__text vkuiSubhead vkuiSubhead--sizeY-regular" style={{marginLeft: 3}}>
        {users
          .map((user) => user.name)
          .join(context.lang().getKey('users_stack', 'short_separator'))
        }
      </span>
    </div>);
  }

  return (<div className="vkuiUsersStack vkuiUsersStack--ios vkuiUsersStack--size-s vkuiUsersStack--l-horizontal UsersStackLong">
    <div role="presentation" className="vkuiUsersStack__photos">
      {users.slice(0, 2).map((user) => (<div className="vkuiUsersStack__photo" key={user.id || user.name || user.img}>
        <UserAvatar type={user.type} src={user.img} name={user.name} size={24} id={user.id} />
      </div>))}
      <div className="" key={'tail'}>
        <UserAvatar name={'+' + (users.length - 2)} size={24} id={users.length - 2} />
      </div>
    </div>
    <div className="vkuiUsersStack__text vkuiSubhead vkuiSubhead--sizeY-regular" style={{marginLeft: 3}}>
        {
          users.slice(0, 2)
            .map((user) => user.name)
            .join(context.lang().getKey('users_stack', 'long_separator')) + context.lang().getKey('users_stack', 'long_tail', '', {countMembers: users.length - 2})
        }
      </div>
  </div>);
}

UsersStack.propTypes = {
  users: PropTypes.arrayOf(CreatorType).isRequired,
};